import React, { useEffect, useRef } from "react";
import { useId } from "react-use-id-hook";
import Form from 'react-bootstrap/Form';
import NumericInput from "react-numeric-input";
const directions = {
  "Top": 0,
  "Right": 1,
  "Down": 2,
  "Left": 3
};
const MultiInputNumberEditor = ({
  label,
  data
}) => {
  var newstringreplaced = data.props.style[label].replace(/px/gi, "px,").split(",");
  const shorthandSplit = newstringreplaced.slice(0, newstringreplaced.length - 1);
  for (let i = 0; i < shorthandSplit.length; ++i) {
    shorthandSplit[i] = shorthandSplit[i].replace(/\s/g, '');
  }
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Label, null, label)), Object.keys(directions).map((key, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: {
        margin: "0px 4px"
      }
    }, key, ":"), /*#__PURE__*/React.createElement(NumericInput, {
      style: {
        margin: 'auto'
      },
      size: "1",
      value: parseInt(shorthandSplit[index]),
      onChange: e => {
        if (e) {
          shorthandSplit[index] = e + "px";
        } else {
          shorthandSplit[index] = "0px";
        }
        data.props.style[label] = shorthandSplit.join(" ");
      }
    }));
  }));
};
const initStyle = (component, property, defaultValue) => {
  if (!component.props.style || !component.props.style[property]) {
    component.props.style = component.props.style || {};
    component.props.style[property] = defaultValue;
  }
  return component.props.style[property];
};
const ContextMenu = ({
  active,
  index,
  setMenuStates,
  coords,
  component,
  data
}) => {
  const id = useId();
  const menuRef = useRef();
  const deactivateMenu = e => {
    if (menuRef.current && e.srcElement && (e === null || e === void 0 ? void 0 : e.srcElement.closest(`div#${id}`)) === null) {
      setMenuStates(index, false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", deactivateMenu);
    return () => {
      document.removeEventListener("click", deactivateMenu);
    };
  });
  if (active && data) {
    const options = {
      "padding": initStyle(data, "padding", "0px 0px 0px 0px"),
      "margin": initStyle(data, "margin", "0px 0px 0px 0px")
    };
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: "component-context-menu",
      style: {
        top: coords[1],
        left: coords[0]
      },
      ref: menuRef
    }, "CSS Menu", /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", null, Object.keys(options).map(key => {
      return /*#__PURE__*/React.createElement(MultiInputNumberEditor, {
        label: key,
        data: data
      });
    })));
  } else {
    return null;
  }
};
export default ContextMenu;